/** Enums de domínio partilhados. Os valores numéricos são persistidos em
 *  Postgres (`smallint`) — nunca reordenar, só acrescentar no fim. */

export const ChannelType = {
  GUILD_TEXT: 0,
  GUILD_VOICE: 1,
  GUILD_CATEGORY: 2,
  DM: 3,
  GROUP_DM: 4,
  GUILD_ANNOUNCEMENT: 5,
  GUILD_FORUM: 6,
  THREAD: 7,
} as const;

export type ChannelTypeValue = (typeof ChannelType)[keyof typeof ChannelType];

export const TEXT_CHANNEL_TYPES: readonly ChannelTypeValue[] = [
  ChannelType.GUILD_TEXT,
  ChannelType.DM,
  ChannelType.GROUP_DM,
  ChannelType.GUILD_ANNOUNCEMENT,
  ChannelType.THREAD,
];

export const VOICE_CHANNEL_TYPES: readonly ChannelTypeValue[] = [ChannelType.GUILD_VOICE];

export const MessageType = {
  DEFAULT: 0,
  MEMBER_JOIN: 1,
  PIN: 2,
  CALL: 3,
  CHANNEL_NAME_CHANGE: 4,
  REPLY: 5,
} as const;

export type MessageTypeValue = (typeof MessageType)[keyof typeof MessageType];

export const MessageFlags = {
  SUPPRESS_EMBEDS: 1 << 0,
  EPHEMERAL: 1 << 1,
  CROSSPOSTED: 1 << 2,
} as const;

export const UserFlags = {
  BOT: 1n << 0n,
  SYSTEM: 1n << 1n,
  STAFF: 1n << 2n,
  VERIFIED: 1n << 3n,
} as const;

export const RelationshipType = {
  PENDING_OUTGOING: 0,
  PENDING_INCOMING: 1,
  FRIEND: 2,
  BLOCKED: 3,
} as const;

export const OverwriteType = {
  ROLE: 0,
  MEMBER: 1,
} as const;

// ─── Limites ─────────────────────────────────────────────────────────────────

export const LIMITS = {
  usernameMin: 2,
  usernameMax: 32,
  displayNameMax: 32,
  bioMax: 190,
  guildNameMin: 2,
  guildNameMax: 100,
  channelNameMax: 100,
  channelTopicMax: 1024,
  roleNameMax: 100,
  messageContentMax: 4000,
  attachmentsPerMessage: 10,
  uploadBytesMax: 25 * 1024 * 1024,
  reactionsPerMessage: 20,
  rolesPerGuild: 250,
  channelsPerGuild: 500,
  bulkDeleteMax: 100,
  historyPageMax: 100,
} as const;

export const USERNAME_RE = /^[a-z0-9_.]+$/;

/** Slowmode permitido, em segundos. */
export const RATE_LIMIT_CHOICES = [0, 5, 10, 15, 30, 60, 120, 300, 600, 900, 3600, 21600] as const;
